"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "verification-body"
  }, [_c('h2', {
    staticClass: "v-title"
  }, [_vm._v("PROCESO DE VERIFICACIÓN")]), _c('p', {
    staticClass: "v-subtitle"
  }, [_vm._v("Completa los pasos para obtener el sello de cuenta verificada y aumentar la confianza de tus suscriptores.")]), _c('div', {
    staticClass: "v-stepper"
  }, _vm._l(3, function (i) {
    return _c('div', {
      key: i,
      staticClass: "step-item",
      class: {
        'active': _vm.currentStep === i,
        'completed': _vm.currentStep > i
      }
    }, [_c('div', {
      staticClass: "step-circle"
    }, [_vm.currentStep > i ? _c('i', {
      staticClass: "fa fa-check"
    }) : _c('span', [_vm._v(_vm._s(i))])]), _c('span', {
      staticClass: "step-label"
    }, [_vm._v(" " + _vm._s(i === 1 ? 'Documento' : i === 2 ? 'Selfie' : 'Prueba Vida') + " ")]), i < 3 ? _c('div', {
      staticClass: "step-line"
    }) : _vm._e()]);
  }), 0), _vm.currentStep === 1 ? _c('div', {
    staticClass: "v-step-content"
  }, [_c('div', {
    staticClass: "v-card"
  }, [_c('h3', [_vm._v("1. Sube tu Documento de Identidad")]), _c('p', [_vm._v("Asegúrate de que la foto sea clara y todos los datos sean legibles.")]), _c('div', {
    staticClass: "doc-upload-grid"
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function ($event) {
        return _vm.simulateUpload('front');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-id-card-o"
  }), _c('span', [_vm._v("Anverso (Frontal)")]), _vm.frontUploaded ? _c('div', {
    staticClass: "uploaded-check"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  })]) : _vm._e()]), _c('div', {
    staticClass: "upload-box",
    on: {
      "click": function ($event) {
        return _vm.simulateUpload('back');
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-id-card-o fa-flip-horizontal"
  }), _c('span', [_vm._v("Reverso (Trasera)")]), _vm.backUploaded ? _c('div', {
    staticClass: "uploaded-check"
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  })]) : _vm._e()])])])]) : _vm.currentStep === 2 ? _c('div', {
    staticClass: "v-step-content"
  }, [_c('div', {
    staticClass: "v-card"
  }, [_c('h3', [_vm._v("2. Tómate una Selfie")]), _c('p', [_vm._v("Sujeta tu documento al lado de tu rostro. Evita usar anteojos o sombreros.")]), _c('div', {
    staticClass: "selfie-box",
    on: {
      "click": function ($event) {
        return _vm.simulateUpload('selfie');
      }
    }
  }, [!_vm.selfieUploaded ? _c('div', {
    staticClass: "camera-placeholder"
  }, [_c('i', {
    staticClass: "fa fa-camera"
  }), _c('span', [_vm._v("Haz clic para tomar/subir selfie")])]) : _c('img', {
    staticClass: "preview-img",
    attrs: {
      "src": "https://picsum.photos/seed/selfie/400/500"
    }
  })])])]) : _vm.currentStep === 3 ? _c('div', {
    staticClass: "v-step-content"
  }, [_c('div', {
    staticClass: "v-card"
  }, [_c('h3', [_vm._v("3. Video de Prueba de Vida")]), _c('p', [_vm._v("Graba un video corto (5 seg) moviendo la cabeza en círculo y diciendo tu nombre.")]), _c('div', {
    staticClass: "video-box",
    on: {
      "click": function ($event) {
        return _vm.simulateUpload('video');
      }
    }
  }, [!_vm.videoUploaded ? _c('div', {
    staticClass: "video-placeholder"
  }, [_c('i', {
    staticClass: "fa fa-video-camera"
  }), _c('span', [_vm._v("Haz clic para grabar video")])]) : _c('div', {
    staticClass: "video-ready"
  }, [_c('i', {
    staticClass: "fa fa-play-circle"
  }), _c('span', [_vm._v("Video cargado correctamente")])])])])]) : _vm._e(), _c('div', {
    staticClass: "v-actions"
  }, [_vm.currentStep > 1 ? _c('button', {
    staticClass: "v-btn-back",
    on: {
      "click": function ($event) {
        _vm.currentStep--;
      }
    }
  }, [_vm._v(" ANTERIOR ")]) : _vm._e(), _c('button', {
    staticClass: "v-btn-next",
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v(" " + _vm._s(_vm.currentStep < 3 ? 'SIGUIENTE' : 'FINALIZAR VERIFICACIÓN') + " ")])])]);
};
var staticRenderFns = exports.staticRenderFns = [];